import { __assign } from "tslib";
import React, { useMemo } from 'react';
import clsx from 'clsx';
import { useUniqueId } from '../internal/hooks/use-unique-id';
import LineSeries from './line-series';
import BarSeries from './bar-series';
import styles from './styles.css.js';
import { calculateOffsetMaps } from './utils';
export default function DataSeries(_a) {
    var innerHeight = _a.innerHeight, innerWidth = _a.innerWidth, highlightedGroupIndex = _a.highlightedGroupIndex, highlightedSeries = _a.highlightedSeries, horizontalBars = _a.horizontalBars, stackedBars = _a.stackedBars, isGroupNavigation = _a.isGroupNavigation, visibleSeries = _a.visibleSeries, xScale = _a.xScale, yScale = _a.yScale, onLineFocus = _a.onLineFocus, onLineBlur = _a.onLineBlur, onLineKeyDown = _a.onLineKeyDown, focusedSeriesRef = _a.focusedSeriesRef;
    var chartAreaClipPath = useUniqueId('awsui-mixed-line-bar-chart__chart-area-');
    var stackedBarOffsetMaps = useMemo(function () {
        if (!stackedBars) {
            return [];
        }
        var barData = [];
        visibleSeries.forEach(function (_a) {
            var series = _a.series;
            if (series.type === 'bar') {
                barData.push(series.data);
            }
        });
        return calculateOffsetMaps(barData);
    }, [visibleSeries, stackedBars]);
    return (React.createElement(React.Fragment, null,
        React.createElement("defs", { "aria-hidden": "true" },
            React.createElement("clipPath", { id: chartAreaClipPath },
                React.createElement("rect", { x: 0, y: 0, width: innerWidth, height: innerHeight }))),
        React.createElement("g", { "aria-hidden": isGroupNavigation ? true : undefined, role: "group" }, visibleSeries.map(function (_a, index) {
            var _b;
            var series = _a.series, color = _a.color;
            var isHighlighted = series === highlightedSeries;
            var isDimmed = !!highlightedSeries && !isHighlighted;
            switch (series.type) {
                case 'line':
                case 'threshold': {
                    // When not using group navigation, series is focusable when either:
                    // 1) it is currently highlighted, or
                    // 2) there is no currently highlighted series and this is the first one in the list
                    var tabIndex = !isGroupNavigation && (isHighlighted || (highlightedSeries === null && index === 0)) ? 0 : -1;
                    var eventHandlers = isGroupNavigation
                        ? {}
                        : {
                            onFocus: function () { return onLineFocus(series); },
                            onBlur: onLineBlur,
                            onKeyDown: onLineKeyDown
                        };
                    return (React.createElement("g", __assign({}, eventHandlers, { key: "line-series-" + index, role: "application", "aria-label": series.title, tabIndex: tabIndex, focusable: tabIndex === 0, ref: isHighlighted ? focusedSeriesRef : undefined, className: clsx(styles.series, styles["series--" + series.type], styles['series--focusable'], (_b = {},
                            _b[styles['series--highlighted']] = isHighlighted,
                            _b[styles['series--dimmed']] = isDimmed,
                            _b)) }),
                        React.createElement(LineSeries, { series: series, color: color, xScale: xScale, yScale: yScale, chartAreaClipPath: chartAreaClipPath })));
                }
                case 'bar':
                    return (React.createElement(BarSeries, { key: "bar-" + index, series: series, color: color, totalSeriesCount: visibleSeries.filter(function (s) { return s.series.type === 'bar'; }).length, seriesIndex: index, xScale: xScale, yScale: yScale, horizontal: horizontalBars, innerSize: horizontalBars ? innerWidth : innerHeight, highlighted: isHighlighted, dimmed: isDimmed, chartAreaClipPath: chartAreaClipPath, stackedBarOffsets: stackedBarOffsetMaps[index], highlightedGroupIndex: highlightedGroupIndex }));
            }
        }))));
}
//# sourceMappingURL=data-series.js.map